import { useListContext, useTranslate } from "ra-core";
import { Fragment } from "react";
import { Separator } from "@/components/ui/separator";

import { Note } from "./Note";
import { NoteCreate } from "./NoteCreate";
import { InfinitePagination } from "../misc/InfinitePagination";
import { ListCardsSkeleton, ListErrorState } from "../design/ListStates";

export const NotesIterator = ({
  reference,
  showStatus,
}: {
  reference: "contacts" | "deals";
  showStatus?: boolean;
}) => {
  const { isPending, error, data = [], refetch } = useListContext();
  const translate = useTranslate();

  return (
    <div className="mt-4">
      <NoteCreate reference={reference} showStatus={showStatus} />
      {isPending ? (
        <div className="mt-4">
          <ListCardsSkeleton rows={3} />
        </div>
      ) : error ? (
        <div className="mt-4">
          <ListErrorState
            message={translate("resources.notes.list.error_loading", {
              _: "Error loading notes",
            })}
            onRetry={() => refetch()}
          />
        </div>
      ) : data.length > 0 ? (
        <div className="mt-4 space-y-4">
          {data.map((note, index) => (
            <Fragment key={note.id}>
              <Note
                note={note}
                isLast={index === data.length - 1}
                showStatus={showStatus}
              />
              {index < data.length - 1 && <Separator />}
            </Fragment>
          ))}
        </div>
      ) : (
        <p className="mt-4 text-sm text-muted-foreground text-center">
          {translate("resources.notes.empty", { _: "No notes yet" })}
        </p>
      )}
      <InfinitePagination />
    </div>
  );
};
